<template>
  <div>
     <v-menu width="220">
          <template v-slot:activator="{ on, attrs }">
              <div  
              v-bind="attrs"
              v-on="on"
              >
         <v-row><span class="colorPickerButton">A</span></v-row>
      <v-row>
          <div class="colorPickerPreviewBar"
        :style="'background-color:'+value+';border:solid 1px black'"
         ></div>
      </v-row>
              </div>
      </template>
      <v-card height="100" width="170">
         <v-card-text >
            <div v-for="item in items" :key="item" 
                    class="d-inline-block pa-3 ml-1 mr-1" 
                    :style="'background-color:'+item+'; border-radius: 50%;border:solid 1px black'"
                    @click="changeColor(item)"
                    >
            </div>
         </v-card-text>
      </v-card>
          
      </v-menu>
  </div>
</template>

<script>
export default {
    name:"ColorPickerPanel",
    props:['items','value'],
    data(){
        return{}
    },
    methods:{
        changeColor(color){
            this.$emit("change",color)
        }
    }
}
</script>

<style>
    .colorPickerButton{
        font-weight: bold;
        font-size: 20px;
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
        -khtml-user-select: none; /* Konqueror HTML */
         -moz-user-select: none; /* Firefox */
          -ms-user-select: none; /* Internet Explorer/Edge */
              user-select: none; /* Non-prefixed version, currently
                                    supported by Chrome and Opera */
    }
    .colorPickerPreviewBar{
        background-color: green;
        height:5px;
        width:15px;
    }
</style>